/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import Vue from 'vue';
import cacheAxios from '../../util/cacheAxios';

const livingCostAxios = axios.create();
const cache = new Map();
cacheAxios(livingCostAxios, cache);

livingCostAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims#/citiescost';
      }, 500);
    }
  });

export default {
  state: {
    cityCostMap: {},
    cityCostIdMap: {},
    cityHardshipRank: {},
    cityMedicalCost: {},
    tipDialogShow: true,
    items: [],
  },
  mutations: {
    setTipDialogShow(state, value) {
      state.tipDialogShow = value;
    },
    setItems(state, value) {
      state.items = value;
    },
    setCityMedicalCost(state, { country, cost }) {
      state.cityMedicalCost = {
        ...state.cityMedicalCost,
        [country]: cost,
      };
    },
    setMultipleCityMedicalCost(state, costs) {
      state.cityMedicalCost = {
        ...state.cityMedicalCost,
        ...costs,
      };
    },
    setCityCostMap(state, costs) {
      state.cityCostMap = {
        ...state.cityCostMap,
        ...costs,
      };
    },
    setCityCostIdMap(state, costs) {
      state.cityCostIdMap = {
        ...state.cityCostIdMap,
        ...costs,
      };
    },
    setCityHardshipRank(state, { country, city, rank }) {
      state.cityHardshipRank = {
        ...state.cityHardshipRank,
        [`${city}|${country}`]: rank,
      };
    },
    setMultipleCityHardshipRank(state, countryRanks) {
      state.cityHardshipRank = {
        ...state.cityHardshipRank,
        ...countryRanks,
      };
    },
  },
  actions: {

    getCostOfLivingItems({ commit }) {
      return livingCostAxios.get('/aims/api/costofliving/items').then((res) => {
        if (res) {
          commit('setItems', res.data);
        }
      });
    },

    saveCostOfLivingCityList(_, list) {
      return livingCostAxios.post('/aims/api/costofliving/saveCostOfLivingCityList', list);
    },

    retrieveCostOfLivingCityList() {
      return livingCostAxios.get('/aims/api/costofliving/userCostOfLivingCityList');
    },

    removeCostOfLivingCityList(_, listName) {
      return livingCostAxios
        .delete(`/aims/api/costofliving/userCostOfLivingCityList/${listName}`);
    },


    getTipDialogShow({ commit }, value) {
      livingCostAxios.get('/aims/api/costofliving/showTipDialog').then((res) => {
        if (res) {
          commit('setTipDialogShow', res.data);
        }
      });
    },
    saveTipDialogShow({ commit }, value) {
      livingCostAxios.get(`/aims/api/costofliving/showTipDialog/${value}`).then((res) => {
        if (res) {
          commit('setTipDialogShow', value);
        }
      });
    },
    getLivingCostIncomeTax(_, { country, income, taxType }) {
      return livingCostAxios.get(
        `/aims/api/costofliving/calcTaxUsd/${country}/${income}/${taxType}`,
        {
          cache: true,
          cacheKey: { country, income, taxType },
        },
      )
      .then((res) => {
        if (res) {
          return res.data;
        }
        return '(Not Available)';
      });
    },
    getLivingCostMedicalCost({ commit }, { country }) {
      livingCostAxios.get(
        `/aims/api/costofliving/medicalCost/${country}/35 - 39`,
      )
      .then((res) => {
        if (res && res.data) {
          commit('setCityMedicalCost', { country, cost: res.data });
        } else {
          commit('setCityMedicalCost', { country, cost: null });
        }
      });
    },
    getMultipleLivingCostHardshipRank({ commit }, { country, cities }) {
      return livingCostAxios.post(
        `/aims/api/costofliving/hardship/${country}`,
        cities,
      )
      .then((res) => {
        if (res && res.data.length > 0) {
          const allCost = {};
          res.data.forEach((city) => {
            allCost[`${city.name.replace(`, ${country}`, '')}|${country}`] = city;
          });
          commit('setMultipleCityHardshipRank', allCost);
        }
      });
    },
    getLivingCostHardshipRank({ commit }, { country, city }) {
      return livingCostAxios.get(
        `/aims/api/costofliving/hardship/${country}/${city}`,
      )
      .then((res) => {
        if (res && res.data) {
          commit('setCityHardshipRank', { city, country, rank: res.data });
        }
      });
    },
    getCityCostAndHardship({ commit }, { city, country }) {
      return livingCostAxios.get(`/aims/api/costofliving/allCostsAndHardship/${country}/${city}`)
      .then((res) => {
        if (res && res.data) {
          if (res.data.hardship && res.data.hardship.name) {
            const hardship = {};
              hardship[`${res.data.hardship.name.replace(`, ${country}`, '')}|${country}`] = res.data.hardship;
            commit('setMultipleCityHardshipRank', hardship);
          }
          if (res.data.cityCostMap && res.data.cityCostMap.city) {
            const costMap = {};
            costMap[`${res.data.cityCostMap.city}|${res.data.cityCostMap.country}`] = res.data.cityCostMap;
            commit('setCityCostMap', costMap);
          }
          if (res.data.cityCostIdMap && res.data.cityCostIdMap.city) {
            const costMap = {};
            costMap[`${res.data.cityCostIdMap.city}|${res.data.cityCostIdMap.country}`] = res.data.cityCostIdMap;
            commit('setCityCostIdMap', costMap);
          }
        }
      });
    },
    getRegionCostHardshipMedicalIncomeTax({ commit }, { region, income, taxType }) {
      return livingCostAxios.get(`/aims/api/costofliving/allCostsHardshipMedicalIncomeTax/${region}/${income}/${taxType}`)
        .then((res) => {
          const cities = {};
          const taxMap = {};
          if (res && res.data) {
            if (res.data.hardships && res.data.hardships.length > 0) {
              const hardships = {};
              res.data.hardships.forEach((city) => {
                hardships[`${city.name.replace(`, ${city.country}`, '')}|${city.country}`] = city;
              });
              commit('setMultipleCityHardshipRank', hardships);
            }
            if (res.data.cityCostMap && res.data.cityCostMap.length > 0) {
              const costMap = {};
              res.data.cityCostMap.forEach((city) => {
                cities[`${city.city}|${city.country}`] = true;
                costMap[`${city.city}|${city.country}`] = city;
              });
              commit('setCityCostMap', costMap);
            }
            if (res.data.cityCostIdMap && res.data.cityCostIdMap.length > 0) {
              const costMap = {};
              res.data.cityCostIdMap.forEach((city) => {
                costMap[`${city.city}|${city.country}`] = city;
              });
              commit('setCityCostIdMap', costMap);
            }
            if (res.data.medicals) {
              commit('setMultipleCityMedicalCost', res.data.medicals);
            }
            if (res.data.taxes) {
              Object.keys(res.data.taxes).forEach((key) => {
                taxMap[`${key}|${income}|${taxType}`] = res.data.taxes[key];
               });
            }
          }
          return { cities, taxMap };
        });
    },
    getCountryCostAndHardship({ commit }, country) {
      return livingCostAxios.get(`/aims/api/costofliving/allCostsAndHardship/${country}`)
      .then((res) => {
        const cities = {};
        if (res && res.data) {
          if (res.data.hardships && res.data.hardships.length > 0) {
            const hardships = {};
            res.data.hardships.forEach((city) => {
              hardships[`${city.name.replace(`, ${country}`, '')}|${country}`] = city;
            });
            commit('setMultipleCityHardshipRank', hardships);
          }
          if (res.data.cityCostMap && res.data.cityCostMap.length > 0) {
            const costMap = {};
            res.data.cityCostMap.forEach((city) => {
              cities[`${city.city}|${city.country}`] = true;
              costMap[`${city.city}|${city.country}`] = city;
            });
            commit('setCityCostMap', costMap);
          }
          if (res.data.cityCostIdMap && res.data.cityCostIdMap.length > 0) {
            const costMap = {};
            res.data.cityCostIdMap.forEach((city) => {
              costMap[`${city.city}|${city.country}`] = city;
            });
            commit('setCityCostIdMap', costMap);
          }
        }
        return { cities, counts: res.data.counts };
      });
    },
    getCountryCost({ commit }, country) {
      return livingCostAxios.get(
        `/aims/api/costofliving/allCosts/${country}`,
      )
      .then((res) => {
        if (res.data.length > 0) {
          const countryCost = {};
          res.data.forEach((city) => {
            const out1 = city.prices.find(it => it.item_name === 'Apartment (1 bedroom) Outside of Centre, Rent Per Month');
            const out3 = city.prices.find(it => it.item_name === 'Apartment (3 bedrooms) Outside of Centre, Rent Per Month');
            const out2 = {
              average_price: (out1.average_price + out3.average_price) / 2,
              highest_price: (out1.highest_price + out3.highest_price) / 2,
              item_name: 'Apartment (2 bedrooms) Outside of Centre, Rent Per Month',
            };
            city.prices.push(out2);
            const in1 = city.prices.find(it => it.item_name === 'Apartment (1 bedroom) in City Centre, Rent Per Month');
            const in3 = city.prices.find(it => it.item_name === 'Apartment (3 bedrooms) in City Centre, Rent Per Month');
            const in2 = {
              average_price: (in1.average_price + in3.average_price) / 2,
              highest_price: (in1.highest_price + in3.highest_price) / 2,
              item_name: 'Apartment (2 bedrooms) in City Centre, Rent Per Month',
            };
            city.prices.push(in2);
            countryCost[`${city.city}|${country}`] = city;
          });
          commit('setCountryCost', countryCost);
        }
      });
    },
    getCityCost({ commit }, { country, city }) {
      return livingCostAxios.get(
        `/aims/api/costofliving/allCosts/${country}/${city}`,
      )
      .then((res) => {
        if (res.data) {
          const out1 = res.data.prices.find(it => it.item_name === 'Apartment (1 bedroom) Outside of Centre, Rent Per Month');
          const out3 = res.data.prices.find(it => it.item_name === 'Apartment (3 bedrooms) Outside of Centre, Rent Per Month');
          const out2 = {
            average_price: (out1.average_price + out3.average_price) / 2,
            highest_price: (out1.highest_price + out3.highest_price) / 2,
            item_name: 'Apartment (2 bedrooms) Outside of Centre, Rent Per Month',
          };
          res.data.prices.push(out2);

          const in1 = res.data.prices.find(it => it.item_name === 'Apartment (1 bedroom) in City Centre, Rent Per Month');
          const in3 = res.data.prices.find(it => it.item_name === 'Apartment (3 bedrooms) in City Centre, Rent Per Month');
          const in2 = {
            average_price: (in1.average_price + in3.average_price) / 2,
            highest_price: (in1.highest_price + in3.highest_price) / 2,
            item_name: 'Apartment (2 bedrooms) in City Centre, Rent Per Month',
          };
          res.data.prices.push(in2);
          commit('setCityCost', { city, country, cost: res.data });
        }
      });
    },
  },
  getters: { },
};



// WEBPACK FOOTER //
// ./src/store/modules/livingCostModule.js